/* eslint-disable */
'use client';

import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  FormControl,
  FormLabel,
  useToast,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  InputGroup,
  InputLeftElement,
  Select,
  Badge,
  Tooltip,
  Icon, // ✅ NEW
} from '@chakra-ui/react';
import { MdEdit, MdDelete, MdSearch, MdDragIndicator } from 'react-icons/md'; // ✅ MdDragIndicator added
import React, { useState, useEffect, useRef } from 'react'; // ✅ useRef added
import axios from 'axios';
import Card from 'components/card/Card';

export default function SubSubjectManagement() {
  const [subjects, setSubjects] = useState([]);
  const [subSubjects, setSubSubjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  const [selectedSubject, setSelectedSubject] = useState('');
  const [subSubjectName, setSubSubjectName] = useState('');
  const [description, setDescription] = useState('');
  const [order, setOrder] = useState('');
  const [subjectStats, setSubjectStats] = useState(null);
  const [filterSubject, setFilterSubject] = useState('');

  // ✅ NEW: Drag-and-drop state
  const [orderedList, setOrderedList] = useState([]);
  const [orderChanged, setOrderChanged] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragItem = useRef(null);
  const hasDragged = useRef(false);

  const [editData, setEditData] = useState({
    id: '',
    name: '',
    subjectId: '',
    description: '',
    order: 0,
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const secondaryColor = useColorModeValue('gray.600', 'gray.400');
  const dragOverBg = useColorModeValue('blue.50', 'navy.700'); // ✅ NEW
  const toast = useToast();

  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchData = async () => {
    try {
      const [subjectRes, subRes] = await Promise.all([
        axios.get(`${baseUrl}api/admin/subjects`, { headers }),
        axios.get(`${baseUrl}api/admin/sub-subjects`, { headers }),
      ]);
      setSubjects(subjectRes.data.data || []);
      setSubSubjects(subRes.data.data || []);
    } catch (err) {
      toast({ title: 'Failed to load data', status: 'error' });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (subjects.length > 0 && !filterSubject) {
      setFilterSubject(subjects[0]._id); // ✅ pehla subject auto-select
    }
  }, [subjects]);

  // ✅ NEW: Sync orderedList whenever data/filters change, reset unsaved drag state
  useEffect(() => {
    const synced = subSubjects
      .filter(
        (item) =>
          (filterSubject
            ? (item.subjectId?._id || item.subjectId)?.toString() ===
              filterSubject
            : true) &&
          (item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.subjectId?.name
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase())),
      )
      .sort((a, b) => (a.order || 0) - (b.order || 0));
    setOrderedList(synced);
    setOrderChanged(false);
  }, [subSubjects, filterSubject, searchTerm]);

  const handleAddSubSubject = async () => {
    if (!subSubjectName || !selectedSubject) {
      return toast({
        title: 'Subject and sub-subject name are required',
        status: 'warning',
      });
    }
    setLoading(true);
    try {
      await axios.post(
        `${baseUrl}api/admin/sub-subjects`,
        {
          name: subSubjectName,
          subjectId: selectedSubject,
          description: description,
          order: parseInt(order) || 0,
        },
        { headers },
      );
      toast({ title: 'Sub-subject added successfully', status: 'success' });
      setSubSubjectName('');
      setDescription('');
      fetchData();
    } catch (err) {
      toast({ title: 'Failed to add sub-subject', status: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // filteredData — existing computed value, untouched
  const filteredData = subSubjects
    .filter(
      (item) =>
        (filterSubject
          ? (item.subjectId?._id || item.subjectId)?.toString() ===
            filterSubject
          : true) &&
        (item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.subjectId?.name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())),
    )
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  const openEditModal = (sub) => {
    setEditData({
      id: sub._id,
      name: sub.name,
      subjectId: sub.subjectId?._id || sub.subjectId,
      description: sub.description || '',
      order: sub.order || 0,
    });
    onOpen();
  };

  const handleUpdate = async () => {
    try {
      await axios.put(
        `${baseUrl}api/admin/sub-subjects/${editData.id}`,
        {
          name: editData.name,
          subjectId: editData.subjectId,
          description: editData.description,
          order: parseInt(editData.order) || 0,
        },
        { headers },
      );
      toast({ title: 'Updated successfully!', status: 'success' });
      onClose();
      fetchData();
    } catch (err) {
      toast({ title: 'Failed to update', status: 'error' });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this?')) {
      try {
        await axios.delete(`${baseUrl}api/admin/sub-subjects/${id}`, {
          headers,
        });
        toast({
          title: 'Subject has been deleted successfully',
          status: 'info',
        });
        fetchData();
      } catch (err) {
        toast({ title: 'Failed to delete subject', status: 'error' });
      }
    }
  };

  // ✅ NEW: Drag handlers — sirf filterSubject selected hone par kaam karte hain
  const handleDragStart = (index) => {
    dragItem.current = index;
    hasDragged.current = false;
  };

  const handleDragEnter = (toIndex) => {
    const fromIndex = dragItem.current;
    if (fromIndex === null || fromIndex === toIndex) return;

    hasDragged.current = true;
    dragItem.current = toIndex; // Ref turant update (re-render se pehle)
    setDragOverIndex(toIndex);

    // Live preview: list ko immediately reorder karo
    setOrderedList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(fromIndex, 1);
      next.splice(toIndex, 0, moved);
      return next;
    });
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // Drop allow karne ke liye zaroori
  };

  const handleDragEnd = () => {
    setDragOverIndex(null);
    if (hasDragged.current) setOrderChanged(true); // Sirf actual move pe show karo
    dragItem.current = null;
    hasDragged.current = false;
  };

  // ✅ NEW: DB mein subject-wise order persist karo
  const handleSaveOrder = async () => {
    if (!filterSubject) {
      return toast({
        title: 'Pehle ek Subject select karein',
        status: 'warning',
      });
    }
    setSavingOrder(true);
    try {
      const items = orderedList.map((item, index) => ({
        id: item._id,
        sortOrder: index + 1, // 1-based sequential order
      }));
      await axios.post(
        `${baseUrl}api/admin/sub-subjects/${filterSubject}/reorder`,
        { items },
        { headers },
      );
      toast({ title: 'Order saved successfully!', status: 'success' });
      setOrderChanged(false);
      fetchData(); // DB se fresh data lo to confirm
    } catch (err) {
      toast({ title: 'Failed to save order', status: 'error' });
    } finally {
      setSavingOrder(false);
    }
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      {/* INPUT CARD — unchanged */}
      <Card mb="20px" p="20px">
        <Text color={textColor} fontSize="22px" fontWeight="700" mb="20px">
          Sub-Subject Management
        </Text>
        <Flex gap="15px" direction="column">
          {subjectStats && (
            <Flex
              bg="blue.50"
              border="1px solid"
              borderColor="blue.200"
              borderRadius="md"
              px="4"
              py="2"
              gap="6"
              align="center"
              fontSize="sm"
            >
              <Text color="blue.700">
                📊 <b>Total Sub-Subjects:</b> {subjectStats.count}
              </Text>
              <Text color="blue.700">
                🔢 <b>Last Order:</b> {subjectStats.lastOrder}
              </Text>
              <Text color="green.700">
                ✅ <b>Suggested Next Order:</b> {subjectStats.nextOrder}
              </Text>
            </Flex>
          )}

          <Flex
            gap="15px"
            direction={{ base: 'column', md: 'row' }}
            align="flex-end"
          >
            <FormControl flex="1">
              <FormLabel fontSize="sm" fontWeight="700">
                Select Main Subject
              </FormLabel>
              <Select
                placeholder="Select Subject"
                value={selectedSubject}
                onChange={(e) => {
                  const val = e.target.value;
                  setSelectedSubject(val);
                  if (val) {
                    const filtered = subSubjects.filter(
                      (s) =>
                        (s.subjectId?._id || s.subjectId)?.toString() === val,
                    );
                    const maxOrder =
                      filtered.length > 0
                        ? Math.max(...filtered.map((s) => s.order || 0))
                        : 0;
                    setSubjectStats({
                      count: filtered.length,
                      lastOrder: maxOrder,
                      nextOrder: maxOrder + 1,
                    });
                    setOrder(String(maxOrder + 1));
                  } else {
                    setSubjectStats(null);
                    setOrder('');
                  }
                }}
              >
                {subjects.map((subject) => (
                  <option key={subject._id} value={subject._id}>
                    {subject.name}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl flex="1">
              <FormLabel fontSize="sm" fontWeight="700">
                Sub-Subject Name
              </FormLabel>
              <Input
                value={subSubjectName}
                onChange={(e) => setSubSubjectName(e.target.value)}
                placeholder="Ex: Organic Chemistry"
              />
            </FormControl>

            <FormControl flex="1">
              <FormLabel fontSize="sm" fontWeight="700">
                Description
              </FormLabel>
              <Input
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Detail..."
              />
            </FormControl>

            <FormControl width="120px">
              <FormLabel fontSize="sm" fontWeight="700">
                Order
                {subjectStats && (
                  <Text as="span" fontSize="xs" color="gray.500" ml="1">
                    (last: {subjectStats.lastOrder})
                  </Text>
                )}
              </FormLabel>
              <Input
                type="number"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
                placeholder="1, 2..."
                min={1}
              />
            </FormControl>

            <Button
              colorScheme="brand"
              onClick={handleAddSubSubject}
              isLoading={loading}
              px="30px"
            >
              Create
            </Button>
          </Flex>
        </Flex>
      </Card>

      {/* LIST CARD */}
      <Card p="20px">
        <Flex justify="space-between" align="center" mb="20px">
          {/* ✅ CHANGED: Title + conditional Save Order button */}
          <Flex align="center" gap="3">
            <Text color={textColor} fontSize="18px" fontWeight="700">
              Sub-Subjects List
            </Text>
            {orderChanged && filterSubject && (
              <Button
                size="sm"
                colorScheme="green"
                onClick={handleSaveOrder}
                isLoading={savingOrder}
                loadingText="Saving..."
              >
                💾 Save Order
              </Button>
            )}
          </Flex>

          <Flex gap="10px" align="center" flexWrap="auto">
            <Select
              value={filterSubject}
              onChange={(e) => setFilterSubject(e.target.value)}
              maxW="200px"
              size="sm"
              borderRadius="md"
            >
              {subjects.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </Select>

            <InputGroup maxW="250px" size="sm">
              <InputLeftElement pointerEvents="none">
                <MdSearch color="gray.300" />
              </InputLeftElement>
              <Input
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                borderRadius="md"
              />
            </InputGroup>
          </Flex>
        </Flex>

        {/* ✅ NEW: Drag hint — sirf subject filter active hone par dikhega */}
        {filterSubject && (
          <Text fontSize="xs" color="gray.400" mb="3">
            ☰ Rows ko drag karke reorder karein → "💾 Save Order" se
            permanently save karein
          </Text>
        )}

        <Box overflowX="auto">
          <Table variant="simple" color="gray.500">
            <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
              <Tr>
                <Th w="40px" px="2"></Th> {/* ✅ NEW: Drag handle column */}
                <Th>No.</Th>
                <Th>Sub-Subject</Th>
                <Th>Main Subject</Th>
                <Th>Description</Th>
                <Th>Order</Th>
                <Th>Status</Th>
                <Th textAlign="right">Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {/* ✅ CHANGED: filteredData → orderedList (drag support ke liye) */}
              {orderedList.map((item, i) => (
                <Tr
                  key={item._id}
                  draggable={!!filterSubject}
                  onDragStart={() => handleDragStart(i)}
                  onDragEnter={() => handleDragEnter(i)}
                  onDragOver={handleDragOver}
                  onDragEnd={handleDragEnd}
                  bg={dragOverIndex === i ? dragOverBg : undefined}
                  transition="background 0.15s ease"
                  userSelect="none"
                >
                  {/* ✅ NEW: Drag handle cell */}
                  <Td px="2">
                    {filterSubject && (
                      <Icon
                        as={MdDragIndicator}
                        color="gray.400"
                        boxSize="5"
                        cursor="grab"
                      />
                    )}
                  </Td>
                  <Td fontSize="sm">{i + 1}</Td>
                  <Td fontWeight="700" color={textColor}>
                    {item.name}
                  </Td>
                  <Td>
                    <Badge colorScheme="blue" variant="subtle">
                      {item.subjectId?.name || 'N/A'}
                    </Badge>
                  </Td>
                  <Td maxW="200px">
                    <Tooltip label={item.description || 'No description'}>
                      <Text isTruncated color={secondaryColor} fontSize="sm">
                        {item.description || '-'}
                      </Text>
                    </Tooltip>
                  </Td>
                  <Td>
                    <Badge colorScheme="orange" variant="subtle">
                      {item.order ?? '-'}
                    </Badge>
                  </Td>
                  <Td>
                    <Badge
                      colorScheme={item.status === 'active' ? 'green' : 'red'}
                    >
                      {item.status}
                    </Badge>
                  </Td>
                  <Td textAlign="right">
                    <IconButton
                      variant="ghost"
                      colorScheme="blue"
                      icon={<MdEdit />}
                      onClick={() => openEditModal(item)}
                      mr="2"
                    />
                    <IconButton
                      variant="ghost"
                      colorScheme="red"
                      icon={<MdDelete />}
                      onClick={() => handleDelete(item._id)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Card>

      {/* EDIT MODAL — unchanged */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Sub-Subject</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb="4">
              <FormLabel>Main Subject</FormLabel>
              <Select
                value={editData.subjectId}
                onChange={(e) =>
                  setEditData({ ...editData, subjectId: e.target.value })
                }
              >
                {subjects.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Sub-Subject Name</FormLabel>
              <Input
                value={editData.name}
                onChange={(e) =>
                  setEditData({ ...editData, name: e.target.value })
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Input
                value={editData.description}
                onChange={(e) =>
                  setEditData({ ...editData, description: e.target.value })
                }
              />
            </FormControl>
            <FormControl mt="4">
              <FormLabel>Order</FormLabel>
              <Input
                type="number"
                value={editData.order}
                onChange={(e) =>
                  setEditData({
                    ...editData,
                    order: parseInt(e.target.value) || 0,
                  })
                }
                placeholder="1, 2, 3..."
                min={1}
              />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="brand" mr={3} onClick={handleUpdate}>
              Update
            </Button>
            <Button onClick={onClose} variant="ghost">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
